const SortingUpIcon = /*#__PURE__*/ [
  ["path", { d: "M18 8.5L5.9999 8.4999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 12.5L3 12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 21.5L16 15.5M16 15.5L18 17.5M16 15.5L14 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 8.5L12 2.5M12 2.5L14 4.5M12 2.5L10 4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M8 21.5L8 15.5M8 15.5L10 17.5M8 15.5L6 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export { SortingUpIcon as default };
//# sourceMappingURL=SortingUpIcon.js.map
